export enum AgreementTypeEnum {
  MANAGEMENT = 'Management',
  LEASE = 'Lease',
  FRANCHISE = 'Franchise',
  MASTER_LEASE = 'MasterLease',
  OWNER_OPERATED = 'OwnerOperated',
}
